<template>
  <div>
    <header-portrate />
    <exports-print v-if="canManage" ref="exportbar" />
    <tabs-comp :tabs="tabs" />
    <main class="m-3 mb-5" :dir="lang.dir">
      <h5>{{lang.item_types_title}}</h5>
      <div class="d-flex flex-wrap my-3">
        <b-button type="button" :disabled="loading || actionBusy" @click="getExpensesTypes">{{lang.update}}</b-button>
        <b-form-checkbox v-if="canManage" class="mx-3" v-model="showArchived" @change="getExpensesTypes">{{lang.status_include_archived}}</b-form-checkbox>
        <b-button v-if="canManage" type="button" :disabled="loading || actionBusy" variant="success" @click="resetMe({id:0})">{{lang.add_new_status}}</b-button>
      </div>
      <p v-if="loading" role="status">{{lang.status_loading}}</p>
      <v-simple-table>
        <thead><tr><th>{{lang.status_code}}</th><th>{{lang.status_name_ar}}</th><th>{{lang.status_name_en}}</th><th>{{lang.status_points_per_100}}</th><th>{{lang.status}}</th><th v-if="canManage">{{lang.action}}</th></tr></thead>
        <tbody>
          <tr v-for="item in expenses" :key="item.id">
            <td :style="{backgroundColor:item.bgColor,color:item.color}">{{item.value}}</td><td>{{item.name_ar}}</td><td>{{item.name_en}}</td><td>{{item.options.points_per_100}}</td><td>{{item.archived?lang.status_archived:lang.status_active}}</td>
            <td v-if="canManage">
              <b-button type="button" size="sm" :disabled="loading || actionBusy" @click="resetMe(item)">{{lang.update}}</b-button>
              <b-button v-if="item.archived" type="button" size="sm" :disabled="loading || actionBusy" @click="changeArchive(item,true)">{{lang.status_restore}}</b-button>
              <b-button v-else-if="item.can_archive" type="button" size="sm" variant="outline-danger" :disabled="loading || actionBusy" @click="changeArchive(item,false)">{{lang.status_archive}}</b-button>
            </td>
          </tr>
          <tr v-if="!loading && !expenses.length"><td :colspan="canManage?6:5">{{lang.status_no_results}}</td></tr>
        </tbody>
      </v-simple-table>
    </main>
    <Footer />
    <addStatusType v-if="canManage" ref="expensType" />
  </div>
</template>
<script>
import TabsComp from '@/components/tabsComp.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import addStatusType from '@/components/addStatusType.vue';
import ExportsPrint from '@/components/exports-print.vue';
import {contextualTabs} from '@/navigation-context';
import axios from 'axios';
export default {
  components:{TabsComp,HeaderPortrate,Footer,addStatusType,ExportsPrint},
  data(){return {currentStatus:'itemTypes',showArchived:false,expenses:[],loading:false,actionBusy:false,requestSerial:0};},
  computed:{
    lang(){return this.$store.state.lang[this.$cookies.get(this.$store.state.LangCooki)||this.$store.state.deflang]||this.$store.state.lang.ar;},
    canManage(){return Number(this.$store.getters.state.group_id)===1;},
    tabs(){const state=this.$store.getters.state;return contextualTabs([],state.menu,state.licenseType,state.group_id,this.$route.path,this.lang.langname,localStorage.getItem('currentMenu'));},
  },
  methods:{
    collectSearch(){return {module:'statusOptions',elements:{phrase:'itemTypes',include_archived:this.canManage&&this.showArchived?1:0,language:this.lang.langname==='en'?'en':'ar'}};},
    resetMe(item){if(!this.canManage||this.loading||this.actionBusy)return false;this.$refs.expensType.resetValues(item,'itemTypes');this.$refs.expensType.visible=true;return true;},
    async getExpensesTypes(){
      const serial=++this.requestSerial;this.loading=true;this.expenses=[];
      const post=new FormData();post.append('type',this.canManage?'getStatusOptions':'getStaticOptions');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('defBranch',localStorage.getItem('defBranch'));post.append('data[phrase]','itemTypes');post.append('data[include_archived]',this.canManage&&this.showArchived?1:0);
      try{const {data}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);if(serial!==this.requestSerial)return false;
        if(Number(data?.error?.number)!==200||!Array.isArray(data.results?.data))throw new Error('invalid');
        this.expenses=data.results.data.map(row=>{
          let options=row.options;if(typeof options==='string'){try{options=JSON.parse(options);}catch(error){options={};}}
          if(!options||typeof options!=='object'||Array.isArray(options))options={};
          return {...row,options:{...options,points_per_100:Number(options.points_per_100)||0}};
        });return true;
      }catch(error){if(serial===this.requestSerial)this.$snotify.error(this.lang.status_load_failed,this.lang.alert);return false;}
      finally{if(serial===this.requestSerial)this.loading=false;}
    },
    async statusSaved(row,phrase){if(phrase==='itemTypes')return this.getExpensesTypes();return false;},
    async changeArchive(item,restore){
      if(!this.canManage||this.actionBusy||this.loading||!item?.id||(!restore&&!item.can_archive))return false;
      if(!window.confirm(restore?this.lang.status_restore_confirm:this.lang.status_archive_confirm))return false;
      this.actionBusy=true;
      const post=new FormData();post.append('type',restore?'restoreStatusOption':'archiveStatusOption');post.append('auth',this.$cookies.get(this.$store.state.COOKIEPhase));post.append('defBranch',localStorage.getItem('defBranch'));post.append('data[id]',item.id);
      try{const {data}=await axios.post(this.$store.state.SAMCOTEC.r_path,post);const saved=data?.results?.data;
        if(Number(data?.error?.number)!==200||Number(saved?.id)!==Number(item.id)||saved.archived!==!restore||saved.option_phrase!=='itemTypes')throw new Error('invalid');
        await this.getExpensesTypes();return true;
      }catch(error){this.$snotify.error(this.lang[error.response?.data?.error?.code]||this.lang.status_save_failed,this.lang.alert);return false;}
      finally{this.actionBusy=false;}
    },
  },
  created(){this.getExpensesTypes();},
  beforeDestroy(){this.requestSerial++;},
}
</script>
